import Api from 'dash/src/services/Api';
import DashPermission from '@vestahealthcare/common/models/DashPermission';

export const fetchDashPermissions = async (): Promise<DashPermission[]> => {
  const { dashPermissions } = await Api.getv2('/dash-permissions');
  return dashPermissions.items.map(
    (dashPermission: any) => new DashPermission(dashPermission),
  );
};
